import {useState} from 'react';
import Modal from 'react-modal';
import FirebaseSignInUI from '../FirebaseSigninUI'
import { useLocalisationService } from "providers/LocalisationProvider";
import { isEmailValid } from 'helpers/is-account-valid';
import { useModalScrollLock } from 'hooks/useModalScrollLock'
import { LocalisedLink } from '../LocalisedLink'
import HtmlParse from 'html-react-parser';

export const SignInModal  = ({authService, isOpen, onClose}) => {

  const l = useLocalisationService();
  const [signupEmailValue,      setSignupEmailValue]      = useState("");
  const [signUpPasswordValue,   setSignUpPasswordValue]   = useState("");
  const [signUpPasswordRepeat,  setSignUpPasswordRepeat]  = useState("");
  const [signInEmailValue,      setSignInEmailValue]      = useState("");
  const [signInPasswordValue,   setSignInPasswordValue]   = useState("");
  const [showPasswordWarning,   setShowPasswordWarning]   = useState(false);
  const [showSignUpError,       setShowSignUpError]       = useState(false);
  const [signUpError,           setSignUpError]           = useState("");
  const [validEmail,            setValidEmail]            = useState(false);
  const [passwordsMatch,        setPasswordsMatch]        = useState(false);
  const [acceptTerms,           setAcceptTerms]           = useState(false);
  const [signInError,           setSignInError]           = useState(null);
  const [isLoading,             setIsLoading]             = useState(false);
  const [isResettingPassword,   setIsResettingPassword]   = useState(false);
  const [passwordResetError,    setPasswordResetError]    = useState(null);
  const [passwordResetSuccess,  setPasswordResetSuccess]  = useState(false);

  const ALREADY_REGISTERED_ERROR = 'auth/email-already-in-use: The email address is already in use by another account.';

  useModalScrollLock(isOpen);

  const renderSignup = () => {
    const canProceed = validEmail && passwordsMatch && acceptTerms;
    return (
      <div className="sign-in-container vfill centered">
        <p>{l.getString('sign_in_sign_up')}</p>

          {renderNewAccountDetailsForm()}
          {renderTermsCheck()}
          <button className="sign-in-button primary-button rounded" disabled={!canProceed} onClick={signUp}>
            {l.getString("sign_in_confirm")}
          </button>
          {renderSignUpWarning()}
      </div>
    );
  }  

  const confirmPasswordRepeat = () => {
    setShowPasswordWarning(!passwordsMatch)
  }
  
  const renderNewAccountDetailsForm = () => {
    const emailInUseStyle = signUpError === ALREADY_REGISTERED_ERROR ? 'danger' : '';
    const passwordRepeatStyle = showPasswordWarning ? 'danger' : '';
    return <form onSubmit={preventDefault}>
      <input type="email" className={emailInUseStyle} autoComplete='username' value={signupEmailValue} placeholder={l.getString("sign_in_email_hint")} onChange={validateEmail} />
      <input type="password" autoComplete='new-password' value={signUpPasswordValue} placeholder={l.getString("sign_in_password_hint")} onChange={validatePassword} />
      <input type="password" className={passwordRepeatStyle} autoComplete='new-password' value={signUpPasswordRepeat} placeholder={l.getString("sign_in_repeat_password_hint")} onChange={validatePasswordRepeat} onBlur={confirmPasswordRepeat} />
    </form>
  }

  const renderSignUpWarning = () => {
    const passwordWarningText = l.getString("sign_up_password_mismatch_warning");
    const accountExistsWarningText = l.getString("sign_up_account_exists_warning");
    const supportWarningText = l.getString("sign_up_support_warning", {error: signUpError});
    const contactSupportText = l.getString("contact_support");

    if(showSignUpError){
      if(signUpError === ALREADY_REGISTERED_ERROR){
        return <>
          <p className="text-danger">{accountExistsWarningText}</p>
        </>
      }
      else{
        return <>
          <p className="text-danger">{supportWarningText} {HtmlParse(contactSupportText)}</p>
        </>
      }
    }

    if(showPasswordWarning){
      return <>
        <p className="text-danger">{passwordWarningText}</p>
      </>
    }
    else{
      return <></>
    }
  }

  const preventDefault = (e) => {
    e.preventDefault();
  }

  const  renderTermsCheck = () => {
    return <div className="sign-in-terms flexbox">
      <span className="small-text">
        <LocalisedLink
          stringKey="sign_in_accept_terms"
          href="tos"
          text={l.getString("homepage_terms")}
          newTab
        />
      </span>
      <input className="rounded" type="checkbox" value={acceptTerms} onChange={handleConsentChange} />
    </div>
  }

  const renderDivider = () => {
    return (
      <div className="sign-in-divider centered flexbox">
        <span>{l.getString("sign_in_divider_text")}</span>
      </div>
    );
  }
  
  const renderSignIn = () => {
    const isValidSignInEmail = signInEmailValue.length > 0 && isEmailValid(signInEmailValue)
    const canProceed = isValidSignInEmail && signInPasswordValue.length > 0 && !isLoading;

    const signInResetString = l.getString("sign_in_reset");
    const emailHintString = l.getString("sign_in_email_hint");
    const cancelString = l.getString("cancel");
    const signInResetInstructionsString = l.getString("sign_in_reset_instructions", { email: signInEmailValue });
    const okString = l.getString("ok");

    const signInHaveAccountString = l.getString("sign_in_have_account");
    const signInEmailHintString = l.getString("sign_in_email_hint");
    const signInPasswordHintString = l.getString("sign_in_password_hint");
    const signInString = l.getString("sign_in");
    const signInForgotString = l.getString("sign_in_forgot");
    const pleaseWaitString = l.getString("please_wait");

    if (isResettingPassword && !passwordResetSuccess) {
      return (
        <form className="sign-in-container vfill centered reset" onSubmit={resetPassword}>
          <p>{signInResetString}</p>
          <input type="email" autoComplete='username' value={signInEmailValue} placeholder={emailHintString} onChange={updateSignInEmail} />
          <p className="text-danger">{passwordResetError}</p>
          <button className="sign-in-button primary-button rounded reset" disabled={!isValidSignInEmail} type="submit">{signInResetString}</button>
          <button className="sign-in-button secondary-button rounded cancel" type="button" onClick={cancelPasswordReset}>{cancelString}</button>
        </form>
      )
    }

    if (isResettingPassword && passwordResetSuccess) {
      return (
        <form className="sign-in-container centered reset">
          <p>{signInResetInstructionsString}</p>
          <button className="sign-in-button primary-button rounded" type="button" onClick={cancelPasswordReset}>
            {okString}
          </button>
        </form>
      )
    }

    return (
      <form className="sign-in-container centered" onSubmit={preventDefault}>
      <p>{signInHaveAccountString}</p>
          <input type="email" autoComplete='username' value={signInEmailValue} placeholder={signInEmailHintString} onChange={updateSignInEmail} />
          <input type="password" autoComplete='current-password' value={signInPasswordValue} placeholder={signInPasswordHintString} onChange={updateSignInPassword} />
          <button className="sign-in-button primary-button rounded" disabled={!canProceed} onClick={signIn}>
            {signInString}
        </button>
        {isLoading && <p className="text-muted">{pleaseWaitString}</p>}
        {signInError && <p className="text-danger">{signInError}</p>}
        <button onClick={() => {setIsResettingPassword(true)}} className="link-button">{signInForgotString}</button>
        <FirebaseSignInUI/>
      </form>
    );
  }

  const validateEmail = (event) => {
    const newEmail = event.target.value;
    setSignupEmailValue(newEmail);
    setValidEmail(newEmail.length > 0);
  }

  const validatePassword = (event) => {
    const newPassword = event.target.value;
    setSignUpPasswordValue(newPassword);
    const passwordsMatch = newPassword === signUpPasswordRepeat;
    setPasswordsMatch(passwordsMatch);
    if(showPasswordWarning && passwordsMatch){
      setShowPasswordWarning(false);
    }
  }

  const validatePasswordRepeat = (event) => {
    const newPasswordRepeat = event.target.value;
    setSignUpPasswordRepeat(newPasswordRepeat);
    const passwordsMatch = signUpPasswordValue === newPasswordRepeat;
    setPasswordsMatch(passwordsMatch);
    if(showPasswordWarning && passwordsMatch){
      setShowPasswordWarning(false);
    }
  }

  const updateSignInEmail = (event) => {
    setSignInEmailValue(event.target.value);
  }

  const updateSignInPassword = (event) => {
    setSignInPasswordValue(event.target.value);
  }

  const signUp = () => {
    authService.createAccount(signupEmailValue, signUpPasswordValue, signUpPasswordRepeat, onFailedSignUp);
  }

  const onFailedSignUp = (error) => {
    setSignUpError(error);
    setShowSignUpError(true);
    if(error === ALREADY_REGISTERED_ERROR){
      setSignInEmailValue(signupEmailValue);
      setIsResettingPassword(true);
    }
  }

  const signIn = async () => {
    setSignInError(null);
    setIsLoading(true);
    await authService.signInWithEmailAndPassword(signInEmailValue, signInPasswordValue, onFailedSignIn);
  }

  const cancelPasswordReset = () => {
    setPasswordResetSuccess(false);
    setIsResettingPassword(false);
  }

  const resetPassword = async (e) => {
    e.preventDefault();
    setPasswordResetSuccess(false);
    setPasswordResetError(false);
    try {
      await authService.resetPassword(signInEmailValue);
      setPasswordResetSuccess(true);
    } catch (error) {
      setPasswordResetError(error.message);
    }
  }

  const onFailedSignIn = (error) => {
    const errorMessage = `${error.code}: ${error.message}`;
    setSignInError(error.message);
    setIsLoading(false);
    console.error(`Sign in error: ${errorMessage}`);
  }

  const handleConsentChange = (event) => {
      setAcceptTerms(event.target.checked);
  }

  return (<Modal
    className="modal signin-modal"
    overlayClassName="modal-overlay signin-modal-overlay"
    isOpen={isOpen}
    onRequestClose={onClose}
    contentLabel="Create Profile">
      <div className='signin-modal-content vfill'>
        {renderSignup()}
        {renderDivider()}
        {renderSignIn()}
      </div>
  </Modal>);
}